export default {
    Attributes: 'attributes',
    Expectations: 'expectations',
  }
  